"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const _currentReducer = require("../../modules/customer/current/reducers");
const _projectsReducer = require("../../modules/project/list/reducers");
const projectUsers = require("./projectUsers");
const currentReducer = _currentReducer.default('management');
const projectsReducer = _projectsReducer.default('management');
//#endregion
//#region INITIAL STATE
exports.initialState = {
    current: Object.assign({}, currentReducer.initialState),
    projects: Object.assign({}, projectsReducer.initialState),
    projectUsers: Object.assign({}, projectUsers.initialState)
};
//#endregion
//#region LENS
const currentLens = monocle.Lens.fromProp('current');
const projectsLens = monocle.Lens.fromProp('projects');
const projectUsersLens = monocle.Lens.fromProp('projectUsers');
//#endregion
//#region REDUCER
const handleCurrent = (action) => (state) => {
    const fn = currentReducer.methods[action.type];
    if (fn) {
        return currentLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleProjects = (action) => (state) => {
    const fn = projectsReducer.methods[action.type];
    if (fn) {
        return projectsLens.modify((s) => fn(s, action))(state);
    }
    return state;
};
const handleProjectUsers = (action) => (state) => {
    const fn = projectUsers.methods[action.type];
    if (fn) {
        const s = projectUsersLens.get(state);
        return projectUsersLens.set(fn(s, action))(state);
    }
    return state;
};
// Reducer
exports.default = (state = exports.initialState, action) => {
    return fp.function.compose(handleCurrent(action), handleProjects(action), handleProjectUsers(action))(state);
};
//#endregion
//# sourceMappingURL=index.js.map